const REFRESH_COOLDOWN_MS = 60_000;
/**
 * Converts a route path pattern (using React Router `:param` syntax) to a
 * RegExp suitable for matching against `window.location.pathname`.
 *
 * Examples:
 *   "/"                              → /^\/$/
 *   "/patients"                      → /^\/patients$/
 *   "/patients/:patientId"           → /^\/patients\/[^/]+$/
 *   "/incident/:id/progress"         → /^\/incident\/[^/]+\/progress$/
 */
export function routePathToRegex(path) {
    const pattern = path
        .split("/")
        .map((segment) => segment.startsWith(":")
        ? "[^/]+"
        : segment.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
        .join("\\/");
    return new RegExp(`^${pattern}$`);
}
export function shouldReloadForVersionMismatch(serverVersion, frontendVersion, pathname, allowedPaths, lastRefreshTimestamp, now) {
    if (!serverVersion)
        return false;
    if (serverVersion === frontendVersion)
        return false;
    if (!allowedPaths.some((pattern) => pattern.test(pathname)))
        return false;
    if (lastRefreshTimestamp &&
        now - Number(lastRefreshTimestamp) < REFRESH_COOLDOWN_MS)
        return false;
    return true;
}
//# sourceMappingURL=versionCheck.js.map